module.exports = __webpack_public_path__ + "img/home-saude.5a6d8f9a.svg";